import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { CustomErrorResponse } from "../../../../CustomComponent/custom_error_response";
import { FcPaid } from "react-icons/fc";
import performRequest from "../../../../api/request";
import { Toast } from "../../../../CustomComponent/toast";
import SimpleButton from "../../../../Components/layouts/simple_button";
import Footer from "../../../../Components/Footer/footer";
import LoadingPage from "../../../../Components/layouts/loading";
import { BsCheck2Square } from "react-icons/bs";
const getImage = (data) => {
  if (data?.pmg_plant?.id) {
    return data?.pmg_plant?.agronomyWikiUpdate?.image;
  }
  if (data?.pmg_accessory?.id) {
    return data?.pmg_accessory?.photo;
  }
};
const getProductName = (data) => {
  if (data?.pmg_plant?.id) {
    return data?.pmg_plant?.agronomyWikiUpdate?.name?.toUpperCase();
  }
  if (data?.pmg_accessory?.id) {
    return data?.pmg_accessory?.name.toUpperCase();
  }
};
const getSku = (data) => {
  if (data?.pmg_plant?.id) {
    return data?.pmg_plant?.plantSKU?.toUpperCase();
  }
  if (data?.pmg_accessory?.id) {
    return data?.pmg_accessory?.accSKU.toUpperCase();
  }
};
const getOrderStatus = (data) => {
  if (data?.status === "accepted") {
    return <span class="badge bg-green text-green-fg">ACCEPTED</span>;
  }
  return <span class="badge bg-red text-red-fg">PENDING</span>;
};

const CuOrderView = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  const [order, setOrder] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [expandedRecipes, setExpandedRecipes] = useState({});
  const [deliveryOtp, setDeliveryOtp] = useState("");

  let { id } = useParams();

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/pmg/order/get-orders/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
          setOrder(res?.data?.order);
        } else {
          Toast("error", "Error while getting Orders!");
        }
        setLoading(false);
      })

      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id, refresh]);

  const handelOrderAcceptance = (Id) => {
    performRequest("PATCH", `/pmg/cf-orders/update-cf-order/${Id}`, {
      status: "accepted",
    })
      .then((res) => {
        if (res.status === 200) {
          Toast("success", "Order status updated successfully!");
          setRefresh(!refresh);
        } else {
          Toast("error", "Error while getting Expense!");
        }
        setLoading(false);
      })

      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };

  const toggleRecipe = (orderItemId) => {
    setExpandedRecipes((prev) => ({
      ...prev,
      [orderItemId]: !prev[orderItemId],
    }));
  };
  const verifyDeliveryOtp = (Id) => {
    // setLoading(true);

    performRequest("POST", `/pmg/order/verify-delivery-otp/${Id}`, {
      otp: deliveryOtp,
    })
      .then((res) => {
        if (res.status === 200) {
          Toast("success", "Delivery confirmed successfully!");
          setRefresh(!refresh);
          setDeliveryOtp("");
        } else {
          Toast("error", "Invalid OTP!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };
  const SummaryRow = ({ label, value, green }) => (
    <div className="d-flex justify-content-between py-1">
      <span className="text-muted">{label}</span>
      <span className={`fw-semibold ${green ? "text-success" : "text-dark"}`}>
        {value}
      </span>
    </div>
  );
  const InfoRow = ({ label, value, bold }) => (
    <div className="d-flex justify-content-between border-bottom py-2">
      <span className="text-muted w-50">{label}</span>
      <span className={bold ? "fw-semibold" : ""}>{value}</span>
    </div>
  );
  const classBasedOnStatus = {
    ongoing: "text-uppercase badge bg-yellow text-white",
    completed: "text-uppercase badge bg-green text-white",
  };
  if (loading) {
    return <LoadingPage />;
  }
  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row align-items-center">
              <div className="col-md-8">
                <h2 className="page-title mb-1">
                  <FcPaid className="fs-2  me-1" /> View Order
                </h2>
              </div>
              <div className="col-md-4">
                <div className="btn-list justify-content-end"></div>
              </div>
            </div>
          </div>
          <div className="row">
            <div style={{ paddingBottom: "120px" }}>
              {/* 📍 Delivery Details */}
              <div className="card mb-3">
                <div className="card-body">
                  <h5 className="mb-3">Delivery Details</h5>
                  <div className="d-flex justify-content-between border-bottom py-2">
                    <span className="text-muted w-50">Status</span>
                    <span className={classBasedOnStatus[order?.status]}>
                      {order?.status}
                    </span>
                  </div>
                  <InfoRow
                    label="Placed on"
                    value={new Date(order?.createdAt).toDateString()}
                  />

                  <InfoRow
                    label="Address"
                    value={`${order?.address?.addressLine1}, ${order?.address?.city}`}
                  />

                  {order?.societyAddress?.societyName && (
                    <InfoRow
                      label="Society Name"
                      value={order?.societyAddress?.societyName}
                    />
                  )}

                  {(order?.societyAddress?.addressLine1 ||
                    order?.societyAddress?.addressLine2) && (
                    <InfoRow
                      label="Society Address"
                      value={`${order?.societyAddress?.addressLine1}, ${order?.societyAddress?.city}`}
                    />
                  )}
                </div>
              </div>
              {/* 🛒 Items */}
              <div className="card mb-3">
                <div className="card-body">
                  <h5 className="mb-3">
                    Items in Order ({order?.items.length})
                  </h5>

                  {order?.items.map((item) => {
                    const isRecipe = !!item.recipe;
                    const isExpanded = expandedRecipes[item.id];

                    if (isRecipe) {
                      return (
                        <div key={item.id} className="border-bottom p-3">
                          <div className="d-flex align-items-center">
                            <img
                              src={item.recipe.image}
                              className="rounded me-3"
                              style={{
                                width: 60,
                                height: 60,
                                objectFit: "cover",
                              }}
                            />

                            <div className="flex-grow-1">
                              <div className="fw-semibold">
                                {item.quantity}x {item.recipe.name}
                              </div>
                              <div className="text-muted">₹{item.total}</div>
                            </div>

                            <button
                              className="btn btn-sm btn-outline-primary"
                              onClick={() => toggleRecipe(item.id)}
                            >
                              {isExpanded ? "Hide" : "View"}
                            </button>
                          </div>

                          {isExpanded && (
                            <div className="mt-3 ps-4">
                              {item.recipe.items.map((ri, index) => (
                                <div
                                  key={ri.id}
                                  className="d-flex justify-content-between border-bottom py-1"
                                >
                                  <span>
                                    {index + 1}) {ri.productName} ×{" "}
                                    {ri.quantity}
                                  </span>

                                  <span className="text-muted">
                                    ₹{ri.itemTotal}
                                  </span>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      );
                    }

                    return (
                      <div
                        key={item.id}
                        className="d-flex align-items-center border-bottom py-2"
                      >
                        <img
                          src={
                            item?.productImage ||
                            "https://via.placeholder.com/60"
                          }
                          className="rounded me-3"
                          style={{
                            width: 60,
                            height: 60,
                            objectFit: "cover",
                          }}
                        />

                        <div className="flex-grow-1">
                          <div className="fw-semibold">
                            {item.quantity} x {item.productName}
                          </div>
                          <div className="text-muted">₹{item.total}</div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>

              {/* 💳 Payment Summary */}
              <div className="card mb-3">
                <div className="card-body">
                  <h5 className="mb-3">Payment Summary</h5>

                  <InfoRow
                    label="Subtotal"
                    value={`₹${order?.summary.subtotal}`}
                  />

                  <InfoRow
                    label="Delivery Fee"
                    value={`₹${order?.summary.subtotal > 399 ? 0 : 45}`}
                  />

                  <InfoRow label="Handling Charges" value="₹11" />

                  {order?.deliveryExecutiveHelp && (
                    <InfoRow label="Quality Care Support" value="₹99" />
                  )}

                  <InfoRow
                    label="Total Paid"
                    value={`₹${order?.summary.grandTotal}`}
                    bold
                  />
                </div>
              </div>
              {/* <div className="card position-fixed bottom-0 start-0 end-0 shadow-lg p-3 bg-white">
                <SummaryRow label="Subtotal" value={`₹ ${total}`} />

                <SummaryRow
                  label="Delivery Fee"
                  value={`₹ ${total > 399 ? 0 : 45}`}
                />

                <SummaryRow label="Handling Charges" value="₹ 11" />

                {deliveryExecutiveHelp && (
                  <SummaryRow label="Quality Care Support" value="₹ 99" />
                )}

                {GRAND_TOTAL > 0 && (
                  <SummaryRow label="Grand Total" value={`₹ ${GRAND_TOTAL}`} />
                )}

                {selectedCoupon && (
                  <SummaryRow
                    label={`Coupon (${selectedCoupon.code})`}
                    value={`- ₹ ${discountAmount}`}
                    green
                  />
                )}

                {walletApplied && (
                  <SummaryRow
                    label="Wallet Used"
                    value={`- ₹ ${walletDeduction}`}
                    green
                  />
                )}

                <button
                  className="btn btn-success w-100 d-flex justify-content-between align-items-center mt-3"
                  onClick={() => placeOrder(GRAND_TOTAL)}
                >
                  <span>Place Order</span>
                  <span>₹ {GRAND_TOTAL}</span>
                </button>

                <div className="text-center mt-2 text-muted small">
                  <i className="bi bi-shield-check me-1"></i>
                  Secure Checkout
                </div>
              </div> */}
              {/* 🔘 Actions */}
              <div className="d-flex justify-content-between">
                {order?.status !== "completed" && (
                  <button
                    className="btn btn-success"
                    data-bs-toggle="modal"
                    data-bs-target="#deliveryOtpModal"
                  >
                    Confirm Delivery
                  </button>
                )}
                <button
                  className="btn btn-outline-secondary"
                  // onClick={() =>
                  //   navigation.navigate("Shipping_Delivery_Policy")
                  // }
                >
                  Get Help with this Order
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="modal fade" id="deliveryOtpModal" tabIndex="-1">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Confirm Delivery</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>

            <div className="modal-body text-center">
              <p className="text-muted">
                Enter the OTP provided by the customer to confirm delivery.
              </p>

              <input
                type="text"
                className="form-control text-center"
                placeholder="Enter Delivery OTP"
                maxLength="6"
                value={deliveryOtp}
                onChange={(e) => setDeliveryOtp(e.target.value)}
              />
            </div>

            <div className="modal-footer">
              <button className="btn btn-secondary" data-bs-dismiss="modal">
                Cancel
              </button>

              <button
                className="btn btn-success"
                disabled={!deliveryOtp || deliveryOtp.length < 6}
                onClick={() => verifyDeliveryOtp(id)}
              >
                Confirm Delivery
              </button>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default CuOrderView;
